(() => {
  const selectors = {
    panel: '[data-ray-search-panel]',
    open: '[data-ray-search-open]',
    close: '[data-ray-search-close]',
    input: '[data-ray-search-input]',
    form: '[data-ray-search-form]',
    results: '[data-ray-search-results]',
    empty: '[data-ray-search-empty]',
    header: '#header-component',
  };

  const state = {
    abortController: null,
    debounceTimer: null,
    lastQuery: '',
  };

  const panel = document.querySelector(selectors.panel);
  const input = document.querySelector(selectors.input);
  const form = document.querySelector(selectors.form);
  const results = document.querySelector(selectors.results);
  const empty = document.querySelector(selectors.empty);

  if (!panel || !input || !form || !results) return;

  const getHeaderBottom = () => {
    const header =
      document.querySelector(selectors.header) ||
      document.querySelector('.header-section') ||
      document.querySelector('header');

    if (!header) return 0;

    const rect = header.getBoundingClientRect();

    return Math.max(0, Math.round(rect.bottom));
  };

 const updateTop = () => {
  document.documentElement.style.setProperty('--ray-search-panel-top', `${getHeaderBottom()}px`);
};

  const showEmpty = () => {
    results.innerHTML = '';
    results.hidden = true;

    if (empty) empty.hidden = false;
  };

  const hideEmpty = () => {
    if (empty) empty.hidden = true;
  };

  // The mega menu only opens/closes via its own pointer-tracking state (see
  // on:pointerleave="/deactivate" in snippets/header-menu.liquid) - it doesn't react to
  // z-index or to other UI opening on top of it. Clicking the search icon doesn't always
  // count as "leaving" the menu for that algorithm, so it can stay open behind the search
  // panel. Force it closed the same way a real pointerleave would.
  const closeActiveMegaMenu = () => {
    const activeLink = document.querySelector('#header-component .menu-list__link[aria-expanded="true"]');
    const activeItem = activeLink?.closest('.menu-list__list-item');

    activeItem?.dispatchEvent(new Event('pointerleave', { bubbles: true, cancelable: true }));
  };

  const openPanel = () => {
    closeActiveMegaMenu();
    updateTop();

    document.body.classList.add('ray-search-panel-open');
    panel.setAttribute('aria-hidden', 'false');

    if (input.value.trim().length === 0) {
      showEmpty();
    }

    window.requestAnimationFrame(() => {
      input.focus();
    });
  };

  const closePanel = () => {
    document.body.classList.remove('ray-search-panel-open');
    panel.setAttribute('aria-hidden', 'true');

    results.hidden = true;
  };

  const getSuggestUrl = (query) => {
    const root = window.Shopify?.routes?.root || '/';
    const url = new URL(`${window.location.origin}${root}search/suggest`);

    url.searchParams.set('q', query);
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', '8');
    url.searchParams.set('resources[options][unavailable_products]', 'last');
    url.searchParams.set('section_id', 'predictive-search');

    return url.toString();
  };

  const renderResults = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nextResults = doc.querySelector('#predictive-search-results');

    if (!nextResults) {
      results.innerHTML = '';
      results.hidden = true;
      return;
    }

    results.innerHTML = nextResults.outerHTML;
    results.hidden = false;
  };

  const fetchResults = async (query) => {
    if (state.abortController) {
      state.abortController.abort();
    }

    state.abortController = new AbortController();

    try {
      const response = await fetch(getSuggestUrl(query), {
        signal: state.abortController.signal,
        headers: {
          Accept: 'text/html',
        },
      });

      if (!response.ok) throw new Error(`Search request failed: ${response.status}`);

      const html = await response.text();

      if (input.value.trim() !== query) return;

      renderResults(html);
    } catch (error) {
      if (error.name === 'AbortError') return;

      results.innerHTML = '';
      results.hidden = true;
    }
  };

  const handleInput = () => {
    const query = input.value.trim();

    window.clearTimeout(state.debounceTimer);

    if (query.length === 0) {
      state.lastQuery = '';
      showEmpty();
      return;
    }

    hideEmpty();

    state.debounceTimer = window.setTimeout(() => {
      if (query === state.lastQuery) return;

      state.lastQuery = query;
      fetchResults(query);
    }, 180);
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest(selectors.open);
    const closeButton = event.target.closest(selectors.close);

    if (openButton) {
  event.preventDefault();

  if (document.body.classList.contains('ray-search-panel-open')) {
    closePanel();
  } else {
    openPanel();
  }

  return;
}

    if (closeButton) {
      event.preventDefault();
      closePanel();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && document.body.classList.contains('ray-search-panel-open')) {
      closePanel();
    }
  });

  // Hovering a nav item while search is open used to leave the mega menu forced empty
  // (visually suppressed by CSS, but still reserving its expanded header height - see
  // assets/ray-search-panel.css). Close search panel on menu hover instead, so the two
  // never try to occupy the header at the same time in either direction.
  document.addEventListener('pointerover', (event) => {
    if (!document.body.classList.contains('ray-search-panel-open')) return;
    if (!event.target.closest('.menu-list__list-item')) return;

    closePanel();
  });

  input.addEventListener('input', handleInput);

  form.addEventListener('submit', (event) => {
    if (input.value.trim().length === 0) {
      event.preventDefault();
      input.focus();
    }
  });

  window.addEventListener('resize', updateTop, { passive: true });
  window.addEventListener('scroll', updateTop, { passive: true });
})();